import React from 'react';
import { SvgIcon } from '@mui/material';

function BinOutlinedIcon() {
  return (
    <SvgIcon viewBox="0 0 12 12" fontSize="12px">
      <path
        /* eslint-disable-next-line max-len */
        d="M6.54545 1.84615H9V2.76923H8.18182V11.0769L7.36364 12H1.63636L0.818182 11.0769V2.76923H0V1.84615H2.45455V0.923077C2.45455 0.678262 2.54075 0.443473 2.69419 0.270363C2.84762 0.0972524 3.05573 0 3.27273 0H5.72727C5.94427 0 6.15238 0.0972524 6.30581 0.270363C6.45925 0.443473 6.54545 0.678262 6.54545 0.923077V1.84615ZM5.72727 0.923077H3.27273V1.84615H5.72727V0.923077ZM1.63636 11.0769H7.36364V2.76923H1.63636V11.0769ZM3.27273 3.69231H2.45455V10.1538H3.27273V3.69231ZM4.09091 3.69231H4.90909V10.1538H4.09091V3.69231ZM5.72727 3.69231H6.54545V10.1538H5.72727V3.69231Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default BinOutlinedIcon;
